import { Role, Order } from "../../models/types";
import { TableColumn } from "../../models/table-types";
import { dateParse, datetimeParse } from "../../hooks/formats";
import { StatusBadge } from "../commons/status-badge";

/**
 * Column configuration for Order table
 * Defines all possible columns with role-based visibility
 */
export const ORDER_COLUMNS: TableColumn<Order>[] = [
  {
    key: "id",
    headerKey: "order_id",
    sortField: "id",
    sortable: true,
    render: (item) => item.id,
  },
  {
    key: "supplier",
    headerKey: "supplier",
    sortField: "supplier_name",
    sortable: true,
    render: (item) => item.supplierName,
    // Hide supplier column for SupplierManager (they only see their own orders anyway)
    roles: [
      Role.WFPManager,
      Role.PartnerManager,
      Role.PartnerStaff,
      Role.WFPReporter,
      Role.MinistryReporter,
    ],
  },
  {
    key: "number_of_items",
    headerKey: "number_of_items",
    sortable: false,
    render: (item) => item.numberOfItems,
    // Show number of items only for SupplierManager
    roles: [Role.SupplierManager],
  },
  {
    key: "partner",
    headerKey: "partner",
    sortField: "partner_name",
    sortable: true,
    render: (item) => item.partnerShortName || item.partnerName,
    // Show to all roles
  },
  {
    key: "content_type",
    headerKey: "content_type",
    sortable: false,  // Computed field from crates, cannot be sorted at database level
    render: (item) => item.contentTitle,
  },
  {
    key: "state",
    headerKey: "state",
    sortField: "state",
    sortable: true,
    render: (item) => (
      <StatusBadge status={item.pendingDiscardRequest ? "DISCARD_REQUESTED" : item.state} />
    ),
  },
  {
    key: "delivery_date",
    headerKey: "delivery_date",
    sortField: "delivery_date",
    sortable: true,
    render: (item) => dateParse(item.deliveryDate),
  },
  {
    key: "last_modified",
    headerKey: "last_modified",
    sortField: "updated_on",
    sortable: true,
    render: (item) => (item.updatedOn ? datetimeParse(item.updatedOn) : ""),
  },
];
